export const FIELD_META_PROP = 'data-__meta'
export const FIELD_DATA_PROP = 'data-__field'



// WEBPACK FOOTER //
// ./components/form/constants.jsx